import React from 'react';
import moment from 'moment';
import { Icon } from '@livable/saas-react-components';
import { Box, Typography } from '@mui/material';
const formatArrival = noteAt => {
  const at = noteAt ? moment(noteAt) : null;
  return at !== null && at !== void 0 && at.isValid() ? at.format('MMM D, YYYY h:mm A') : '';
};

/**
 * What the customer wrote to our team with the bill (LB-6056): the email's text, or the note typed at upload, with
 * who wrote it and when. Shown as it was written, as plain text -- it comes from outside the company -- and only
 * shown: nothing about how the bill is read, matched or allocated follows from it.
 */
export const BillNoteBlock = _ref => {
  let note = _ref.note,
    noteBy = _ref.noteBy,
    noteAt = _ref.noteAt;
  if (!note) return null;
  const arrival = formatArrival(noteAt);
  const byline = [noteBy ? "From ".concat(noteBy) : 'From the customer', arrival].filter(Boolean).join(' · ');
  return /*#__PURE__*/React.createElement(Box, {
    component: "section",
    "aria-label": "Note for our team",
    sx: {
      display: 'flex',
      gap: 1,
      p: 1.5,
      mb: 2,
      borderRadius: 1,
      border: '1px solid',
      borderColor: 'divider'
    },
    'custom-attribute': 'bill-details-note'
  }, /*#__PURE__*/React.createElement(Box, {
    component: "span",
    sx: {
      display: 'inline-flex',
      pt: 0.25
    },
    "aria-hidden": true
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "message",
    state: "info",
    fontSize: "small"
  })), /*#__PURE__*/React.createElement(Box, {
    sx: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    sx: {
      fontWeight: 600
    }
  }, "Note for our team"), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "text.secondary",
    component: "div",
    sx: {
      mb: 0.5
    }
  }, byline), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    sx: {
      whiteSpace: 'pre-wrap',
      overflowWrap: 'anywhere'
    }
  }, note)));
};